(ns common.schema.assets)

(def all-asset-types [:entity.type/company :entity.type/real-estate :entity.type/fof-asset :entity.type/other-asset])

(def asset-type? (set all-asset-types))

(def customer-types [:entity.type/company
                     :entity.type/person
                     :entity.type/investor])

(def customer-types-set (set customer-types))

;; For now: adding these here so these can be found by searching for :entity.type/customer / :entity.type/asset
;; TODO define an entity-type hierarchy somewhere, in order to get a list of matching :field/entity-types
;;  e.g. entity-merge filters fields based on knowledge that :entity.type/person is also
;;       an :entity.type/customer and :entity.type/any
;;       => figure out a way to do this without explicitly having to remember to match with :entity.type/any etc.
(def asset-customer-mappings
  {:entity.type/asset all-asset-types
   :entity.type/customer customer-types})

(defn concrete-entity-types
  "Expand abstract types (:entity.type/asset, :entity.type/customer) in
   `entity-types` into their concrete subtypes via asset-customer-mappings.
   Types with no mapping pass through unchanged."
  [entity-types]
  (->> entity-types
       (mapcat (fn [entity-type]
                 (or (get asset-customer-mappings entity-type)
                     [entity-type])))
       distinct
       vec))

(def target-asset-type-mappings {:entity.type/oppo              all-asset-types
                                 :entity.type/holding           all-asset-types
                                 :entity.type/sales-opportunity customer-types})

(def required-feature {:entity.type/company     :feature/asset-types-company
                       :entity.type/fof-asset   :feature/asset-types-fof
                       :entity.type/other-asset :feature/asset-types-other
                       :entity.type/real-estate :feature/asset-types-real-estate
                       :entity.type/person      :feature/sales-pipelines
                       :entity.type/investor    :feature/sales-pipelines})

(def target-attribute
  {:entity.type/oppo :oppo/target-asset
   :entity.type/holding :holding/target-asset
   :entity.type/sales-opportunity :sales-opportunity/customer})
